import {config} from "@/constants/config";
import {httpRequest} from "@/providers/http";

export interface GameLaunchApiResponse {
  data?: {
    data?: {
      gameUrl?: string | null;
    };
  };
}

export interface GameLaunchResult {
  gameUrl: string | null;
}

export interface GetGameLaunchParams {
  provider: string;
  gameId: string;
  currency?: string;
  isMobile?: boolean;
}

export const getGameLaunchService = async ({
  provider,
  gameId,
  currency,
  isMobile,
}: GetGameLaunchParams): Promise<GameLaunchResult> => {
  const response = await httpRequest<GameLaunchApiResponse>({
    method: "GET",
    baseUrl: config.legacy.API_URL.GAMES_INIT,
    url: `/${encodeURIComponent(provider)}/${encodeURIComponent(gameId)}`,
    query: {
      currency: currency ?? config.defaultCurrency,
      is_mobile: Boolean(isMobile),
    },
  });
  return {gameUrl: response?.data?.data?.gameUrl ?? null};
};
